import { getSupabase } from "../supabase";

import { commercialFromRow, type CommercialState } from "./commercialState.mjs";

/**
 * MER-486: fetch a customer's commercial state from the staff-only
 * tenant_commercial table (migration 0039). Replaces the MER-212 v1
 * bundled-YAML source, which was publicly fetchable and therefore
 * unfit for MRR / contact / contract data (AJ decision on MER-185).
 *
 * Returns null when no row exists for the tenant; the panel renders
 * its "Not configured" state. RLS limits SELECT to staff, so a
 * non-staff session gets no rows rather than an error.
 */
export async function fetchCommercialState(tenantId: string): Promise<CommercialState | null> {
  const supabase = getSupabase();
  const { data, error } = await supabase
    .from("tenant_commercial")
    .select(
      "tenant_id, partner_name, partner_email, partner_role, mrr_usd, contract_start, contract_end, notes",
    )
    .eq("tenant_id", tenantId)
    .maybeSingle();
  if (error) throw new Error(`fetchCommercialState failed: ${error.message}`);
  return commercialFromRow(data);
}
